export const whiteLabelConstants = {
    GET_WHITE_LABEL_REQUEST: 'GET_WHITE_LABEL_REQUEST',
    GET_WHITE_LABEL_SUCCESS: 'GET_WHITE_LABEL_SUCCESS',
    GET_WHITE_LABEL_FAILURE: 'GET_WHITE_LABEL_FAILURE',
    SUBMIT_WHITE_LABEL_REQUEST: 'SUBMIT_WHITE_LABEL_REQUEST',
    SUBMIT_WHITE_LABEL_SUCCESS: 'SUBMIT_WHITE_LABEL_SUCCESS',
    SUBMIT_WHITE_LABEL_FAILURE: 'SUBMIT_WHITE_LABEL_FAILURE',
    LOAD_DOMAIN_CONFIG_REQUEST: 'LOAD_DOMAIN_CONFIG_REQUEST',
    LOAD_DOMAIN_CONFIG_SUCCESS: 'LOAD_DOMAIN_CONFIG_SUCCESS'
}